/*global ga*/
"use strict";

import $ from "jquery";
import toastr from "toastr";
import gaCheck from "./util/ga_check";
import debounce from "lodash/debounce";
import adjustPieChartCenterText from "./util/adjust_pie_chart_title";

const toggleCardAttribute = function (link, card, attr, action, options) {
  const id = $(card).data("card-id");
  const oldContents = $(link).html();
  $(link).html("<i class=\"fa fa-fw fa-cog fa-spin\"></i>");
  let dataOrNothing;
  if (options && options.extraData) {
    dataOrNothing = options.extraData(card, action);
  }
  $.ajax(`/cards/${id}/${action}`, {
    method: "POST",
    data: dataOrNothing,
    success: function () {
      var newValue = !card.data(`card-${attr}`);
      card.attr(`data-card-${attr}`, newValue).data(`card-${attr}`, newValue);

      $(link).html(oldContents);
      $(card).trigger(action + ".wd.card");
    },
    error: function () {
      toastr.error(`Error: Failed to ${action} card`, "", {
        "positionClass": "toast-bottom-center",
      });
    }
  });
};

// Wtf am I doing?
const makeHandler = function (attr, action, options) {
  return function () {
    const card = $(this).closest("[data-card]");
    let link = $(this);
    let act;

    if (link[0].pathname && (link[0].pathname == "/downloads" || link[0].pathname.match(/\/go\/download_card/))) return;

    if (card.data(`card-${attr}`)) {
      act = "un" + action;
    } else {
      act = action;
    }

    if (options && options.target) {
      link = card.find(options.target);
      if (act === "unexpand") {
        if ($(this).is(options.doNotUnexpand) && link[0]) {
          return true;
        } else {
          card.find(".see-data-button").text("See data");
          // The BS3-era cleanup added `.collapse` to the tab BUTTONS/`li`s — visually inert under
          // BS3 (`.nav > li`/`.btn` display rules won the cascade), but BS5's
          // `.collapse:not(.show) { display: none }` genuinely hides the tab row on collapse,
          // orphaning any open pane. Deactivate the PANES instead so
          // collapsing the card closes the open tab, and leave the buttons available.
          const tabContainer = card.find(".forecast-commentary-card-tab-container");
          tabContainer.find("li, .forecast-card-tab-button").removeClass("in show collapse active");
          tabContainer.find(".tab-pane").removeClass("in show active");
          tabContainer.find(".panel-collapse").removeClass("in show").addClass("collapse");
          tabContainer.find(".forecast-card-tab-button").attr("aria-expanded", false);
        }
      }
    }

    toggleCardAttribute(link, card, attr, act, options);

    if (act === "unexpand" || act === "expand") {
      return link[0] !== this;
    } else {
      return false;
    }
  };
};

const chartsFromCard = function (card) {
  const chartDivs = $(card).closest("[data-card]").find("[data-highcharts-chart]");

  return chartDivs.map(function () { return $(this).highcharts(); }).get();
};

const adjustSpotChartSvgExtraFluff = function (chart, card) {
  const paths = $(card).find("path[fill='none'].highcharts-plot-line");
  const vertical = paths[0];
  const horizontal = paths[2];

  const verticalDSplit = vertical.attributes.d.nodeValue.split(" ");
  const vertX = +verticalDSplit[1],
    vertTopY = +verticalDSplit[2],
    vertBotY = +verticalDSplit[5];

  $(card).find("path.top-triangle").remove();
  chart
    .renderer
    .path(["M", vertX - 10, vertTopY + 1, "L", vertX + 10, vertTopY + 1, vertX, vertTopY - 11, "Z"])
    .attr({ fill: "black", class: "top-triangle" })
    .add();

  $(card).find("path.bottom-triangle").remove();
  chart
    .renderer
    .path(["M", vertX - 10, vertBotY - 1, "L", vertX + 10, vertBotY - 1, vertX, vertBotY + 11, "Z"])
    .attr({ fill: "black", class: "bottom-triangle" })
    .add();

  const horizontalDSplit = horizontal.attributes.d.nodeValue.split(" ");
  const horizLeftX = +horizontalDSplit[1],
    horizY = +horizontalDSplit[2],
    horizRightX = +horizontalDSplit[4];

  $(card).find("path.left-triangle").remove();
  chart
    .renderer
    .path(["M", horizLeftX + 1, horizY - 10, "L", horizLeftX + 1, horizY + 10, horizLeftX - 11, horizY, "Z"])
    .attr({ fill: "black", class: "left-triangle" })
    .add();

  $(card).find("path.right-triangle").remove();
  chart
    .renderer
    .path(["M", horizRightX - 1, horizY - 10, "L", horizRightX - 1, horizY + 10, horizRightX + 11, horizY, "Z"])
    .attr({ fill: "black", class: "right-triangle" })
    .add();
};

const cardResizedAdjustVisualization = function (_i, card, forceLegendShow) {
  const charts = chartsFromCard(card);
  $.each(charts, function (i, chart) {
    const spotChart = $(chart.container).closest(".spot-chart")[0];
    const donutChart = $(chart.container).closest(".donut-chart")[0];
    if (chart) {
      const width = $(card).find(".card-body").width();

      if (width && width < 700 && !forceLegendShow) {
        chart.legendHide();
      } else {
        chart.legendShow();
      }

      chart.isDirtyBox = true;
      chart.redraw();
      chart.reflow();

      if (spotChart) {
        adjustSpotChartSvgExtraFluff(chart, card);
      }

      if (donutChart) {
        adjustPieChartCenterText(chart, card);
      }
    }
  });
};

const reflowChart = function (e) {
  const card = e.target;
  window.setTimeout(() => cardResizedAdjustVisualization(null, card), 400);

  $(".leaflet-map-container").trigger("leafresize");
  $(".diagram-wrapper").trigger("diagramresize");
};

const renameExpandLink = function (e) {
  const link = $(e.target).find("[data-expand]");
  const text = e.type == "expand" ? "Collapse Card" : "Expand Card";
  link.text(text);
};

const trackCardAction = function (e) {
  if (!gaCheck()) {
    return;
  }
  ga("send", {
    hitType: "event",
    eventCategory: "Cards",
    eventAction: e.type,
    eventValue: $(this).data("card-id")
  });
};

const resizeText = function (e) {
  const card = $(e.target);
  // TODO: Rewrite this for clarity
  if (card.data().cardSize !== "xlarge" && !card.data().expanded && card.find(".preview-content").length > 0) {
    const content = card.find(".content");
    // A `.content` that carries a visualization must NEVER be cloned into `.always-full-content`
    // (nor swapped out for the clone). The clone exists solely to show UNTRUNCATED text
    // (`.content` may be dotdotdot-truncated in the collapsed state below); a visualization is
    // never truncated (see the dotdotdot guard below), so the clone adds nothing for viz cards —
    // and cloning the still-loading spinner shell duplicates the server-rendered
    // `#visualization-inner-wrapper-<uid>` id, which strands the deferred chart render in the
    // hidden copy: on a per-account EXPANDED card the clone is swapped in as the visible element
    // and stays "Loading…" forever (e.g. cards 412352/304405).
    const hasVisualization = content.find(".visualization-inner-wrapper").length > 0;

    if (!hasVisualization && card.find(".always-full-content").length === 0) {
      content.after(content.clone().addClass("always-full-content").removeClass("content").hide());
    }

    if (card.data().cardExpanded) {
      if (hasVisualization) {
        card.find(".always-full-content").hide();
        card.find(".preview-content").hide();
        content.show();
      } else {
        content.hide();
        card.find(".always-full-content").show();
      }
    } else {
      card.find(".always-full-content").hide();
      card.find(".preview-content").show();
      content.hide();

      const cardHeight = card.height();

      const parentHeight = card.parent().height();
      const cardTitleHeight = card.find(".card-title").height();
      const cardControlsHeight = card.find(".card-controls").height();

      if (cardHeight < parentHeight) {
        card.find(".preview-content").hide();

        content.show();
        // A card whose content carries a visualization must NOT be dotdotdot-truncated.
        // dotdotdot caches the content at init time (for a deferred viz that is the loading
        // spinner) and its `watch` interval periodically restores that cached copy — clobbering
        // the chart that `delayedVisualizationRender` injects asynchronously, leaving the visible
        // `.content` stuck on "Loading…"/"…" while the chart survives only in the hidden
        // `.always-full-content` clone (a residual case,
        // e.g. ExcelPieChart card 412352). Ellipsis-truncating a chart is meaningless anyway.
        if (content.find(".visualization-inner-wrapper").length === 0) {
          content.dotdotdot({
            height: parentHeight - 2 * cardTitleHeight - 2 * cardControlsHeight,
            watch: true
          });
        }
      }
    }
  }
};

const expandCardHandler = function (e, pageSetupAction = false) {
  const $container = $(e.target).closest(".card-container");
  $container.toggleClass("expanded");

  if (!pageSetupAction) {
    $container.find("a.anchor")[0].scrollIntoView();
  }

  reflowChart(e, pageSetupAction);
  resizeText(e, pageSetupAction);
  renameExpandLink(e, pageSetupAction);
};

const expandCard = function (e) {
  expandCardHandler(e);
};

const hideDataTable = function () {
  const $card = $(this).closest(".card-container");

  const $downloadButton = $card.find("a.extra-card-button");
  if ($downloadButton.closest(".forecast-commentary-card-tab-container").length === 0)  {
    $downloadButton.addClass("hidden");
  }
  $card.find("div.chart-values-datatable-wrapper").collapse("hide");
};

const reflowAllCharts = function () {
  $("[data-card]").each(function () { reflowChart({ target: this }); });
};


const resizeAllTexts = function () {
  $("[data-card]").each(function () { resizeText({ target: this }); });
};

const exportChart = function (e) {
  const card = e.target;
  const charts = chartsFromCard(card);

  if (charts.length > 0) {
    $.each(charts, function (i, chart) {
      chart.exportChart();
    });
  }

  e.preventDefault();
  e.stopPropagation();
};

const expandRegionCard = function () {
  var clickedLink = $(this);
  var id = "#" + clickedLink.prop("href").split("#")[1];
  var link = $(id);
  var card = link.next();

  if (!card.data().cardExpanded) {
    // card.addClass("expanded");
    card.find("a[data-expand]").trigger("click");
  }
  window.setTimeout(function () { link[0].scrollIntoView(); }, 500);
};

const negateSvgLinksOnMobile = () => {
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    let $svgs = [];
    const checkSvgs = setInterval(() => {
      if ($("svg").length > $svgs.length) {
        $svgs = $("svg");
      } else {
        $("svg").on("click", e => {
          e.preventDefault();
        });
        clearInterval(checkSvgs);
      }
    }, 2000);
  }
};

$(window).on("resize", debounce(reflowAllCharts, 100));
$(window).on("resize", debounce(resizeAllTexts, 100));

// Delegated on `document` (not bound inside initCards) for two reasons:
// 1. Many cards render their chart/tab markup asynchronously, well after
//    `initCards()` has already run (see `delayedVisualizationRender` in
//    global.js) — a plain `$(".forecast-card-tab-button").on(...)` binding only
//    attaches to buttons that already exist in the DOM at bind time, so any
//    button injected later never gets it. Delegating on `document` matches
//    regardless of when the element appears, the same way BS5's own tab-toggle
//    listener does (which is why the *first* click on a late-rendered tab
//    already worked via Bootstrap, but a second click to close it didn't).
// 2. `initCards()` re-runs on every `turbolinks:load`, and `document` itself is
//    never replaced/recreated the way turbolinks swaps out `<body>` — a
//    delegated handler bound inside `initCards()` would pile up one extra
//    listener per navigation instead of being naturally dropped along with the
//    old DOM.
//
// BS5 registers its own tab click handler on `document` in the CAPTURE phase
// (needed so its delegated selector match can walk up from event.target), which
// always runs before a plain bubble-phase handler — so by the time the "click"
// handler below runs, BS5 has ALREADY opened a brand-new tab for this same
// click. Checking classes at click-time can't tell "was already open" apart
// from "BS5 just opened it a moment ago", so the "was it open" snapshot is
// taken on mousedown instead, before BS5's handler (which only listens for
// click) has run at all. BS5's Tab plugin leaves the pane with `.show` (not
// `.active` — see the `.tab-pane.show` visibility rule in wd-cards.scss), so
// that's the class that actually reflects "currently open".
$(document).on("mousedown", '.forecast-card-tab-button[data-bs-toggle="tab"]', function () {
  const $target = $($(this).attr("href"));
  $(this).data("wasShownBeforeClick", $target.is(".active, .show"));
});

$(document).on("click", '.forecast-card-tab-button[data-bs-toggle="tab"]', function (e) {
  const $this = $(this);
  const $target = $($this.attr("href"));

  if ($this.data("wasShownBeforeClick")) {
    $target.removeClass("active show");
    $this.removeClass("active").attr("aria-selected", false).attr("aria-expanded", false);
    $this.closest("li").removeClass("active");

    e.preventDefault();
    e.stopPropagation();
  }
});

const initCards = function () {
  $(".region-list-link").on("click", expandRegionCard);

  $("[data-pin]").on("click", makeHandler("pinned", "pin"));
  $("[data-expand], .see-data-button, .forecast-card-tab-button:not(.link-to-opportunity)").on("click", makeHandler("expanded", "expand", {
    target: "[data-expand]",
    doNotUnexpand: ".see-data-button, .forecast-card-tab-button"
  }));

  negateSvgLinksOnMobile();

  $("[data-card]").on("pin.wd.card unpin.wd.card expand.wd.card unexpand.wd.card", trackCardAction);

  $("[data-card]").on("unexpand.wd.card", hideDataTable);
  $("[data-card]").on("expand.wd.card unexpand.wd.card", expandCard);

  $("[data-card]").on("show.bs.collapse", reflowChart);
  $("[data-card]").each(cardResizedAdjustVisualization);
  $("[data-export]").on("click", exportChart);
  resizeAllTexts();

  $(".notify-me-button").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    $.ajax({
      url:  "/analytics_messages/request_notification",
      type: "post",
      data: { outbound_extras: { notification_for: "US Forecasts" } },
      dataType: "json",
      success: function () {},
      error: function () {}
    });

    toastr.success("Thank you for your interest. We will contact you when this data is published.", "", {
      "positionClass": "toast-bottom-center",
    });
  });
};

const updateCardStates = function (mapping) {
  if (mapping && mapping.pinned) {
    mapping.pinned.map((id) => {
      const $card = $(`.card[data-card-id="${id}"]`);

      $card.data("card-pinned", true);
      $card.attr("data-card-pinned", "true");
    });
  }

  if (mapping && mapping.expanded) {
    mapping.expanded.map((id) => {
      const $card = $(`.card[data-card-id="${id}"]`);

      $card.data("card-expanded", true);
      $card.attr("data-card-expanded", "true");

      if ($card[0]) {
        expandCardHandler({ target: $card[0], type: "expand" }, true);
      }
    });
  }
};

$(document).on("turbolinks:load", initCards);

export { cardResizedAdjustVisualization, chartsFromCard, initCards, updateCardStates, };
